import { AdminPanelContext } from "./context";
import React, { useState } from "react";

export const AdminPanelWrapper = ({ children }) => {
  const [value, setValue] = useState("appAndCategory");
  const [formValue, setFormValue] = useState({});
  const [bannerNotification, setBannerNotification] = useState([]);
  const [formTriggerSuccess, setFormTriggerSuccess] = useState(false);

  return <AdminPanelContext.Provider value={{ value, setValue,formValue, setFormValue,bannerNotification, setBannerNotification,formTriggerSuccess, setFormTriggerSuccess }}>{children}</AdminPanelContext.Provider>;
};
